import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';
import { isEqual } from 'lodash-es';
import { WebUI } from "../../wui-core/src/index.js";
import omit from "omit.js";
var propTypes = {
  clsPrefix: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  defaultValue: PropTypes.array,
  name: PropTypes.string
};
var defaultProps = {
  clsPrefix: 'u-checkbox-group',
  className: '',
  value: [],
  defaultValue: [],
  onChange: function onChange() {},
  disabled: false,
  options: [],
  name: ''
};
var CheckboxGroup = (_dec = WebUI({
  name: "checkbox-group",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "changeHandle", function (v) {
      var values = _this.state.values;

      if (values.indexOf(v) != -1) {
        values.splice(values.indexOf(v), 1);
      } else {
        values.push(v);
      }

      _this.setState({
        values: values
      });

      var onChange = _this.props.onChange;

      if (onChange) {
        var options = _this.getOptions();

        onChange(values.filter(function (val) {
          return values.indexOf(val) !== -1;
        }).sort(function (a, b) {
          var indexA = options.findIndex(function (opt) {
            return opt.value === a;
          });
          var indexB = options.findIndex(function (opt) {
            return opt.value === b;
          });
          return indexA - indexB;
        }));
      }
    });

    _this.state = {
      values: props.value || props.defaultValue || []
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value && !isEqual(nextProps.value, this.state.values)) {
        this.setState({
          values: nextProps.value
        });
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;
      return options.map(function (option) {
        if (typeof option === 'string') {
          return {
            label: option,
            value: option
          };
        }

        return option;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state;
      var props = this.props;
      var clsPrefix = props.clsPrefix,
          className = props.className,
          disabled = props.disabled,
          children = props.children,
          options = props.options,
          name = props.name;
      var otherProps = {};

      if (name) {
        otherProps.name = name;
      }

      var classes = clsPrefix;
      console.log('state.values: ', state.values);
      if (className) classes += ' ' + className;

      if (options && options.length > 0) {
        children = this.getOptions().map(function (option) {
          return /*#__PURE__*/React.createElement(Checkbox, _extends({
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : props.disabled,
            value: option.value,
            checked: state.values.indexOf(option.value) !== -1,
            onChange: option.onChange
          }, otherProps), option.label);
        });
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes
      }, omit(otherProps, "antd")), React.Children.map(children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          onChange: function onChange() {
            _this2.changeHandle(child.props.value);
          },
          checked: state.values.indexOf(child.props.value) != -1,
          disabled: child.props.disabled || disabled
        });
      }));
    }
  }]);

  return CheckboxGroup;
}(React.Component)) || _class);
CheckboxGroup.propTypes = propTypes;
export default CheckboxGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-checkbox/src/CheckboxGroup.js